import React from 'react'
import HeatMap from "../../components/HeatMaps"

const MoreReportPage = () => {
  const positions = [
    "top-10 right-48",
    "top-[230px] right-[360px]",
    "top-[320px] right-[560px]",
    "top-[420px] right-[410px]",
    "bottom-[450px] left-[480px]",
    "bottom-[500px] right-[160px]",
    "bottom-[130px] left-1/3",
    "bottom-[200px] right-[480px]",
  ]

  return (
    <div className='bg-white'>
      <HeatMap />
      <div className="flex justify-between items-start md:mt-5 mt-3 md:px-28 ">
  <div></div> {/* Empty div to push the button to the right */}
  
  <div>
  <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
    <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-9 md:w-[255px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
    CONTACT ADMIN
    </p>
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
      alt="Expand"
      className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
    />
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
      alt="Expand"
      className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
    />
  </div>
  <p className='md:text-[10px] text-[4px] font-normal md:mt-0 mt-1'>Contact administrator for more information</p>
  </div>
</div>
<div className='md:h-14 h-3'></div>
    </div>
  )
}

export default MoreReportPage
